import { LeagueBadge } from './LeagueBadge';

export default LeagueBadge;
